function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
import { ViewType } from './types';
const baseUrl = '/view-filters';
const baseUrlProject = '/view-filters/project';
export class ViewClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getAllViews", (viewType, sharedOnly, viewSourceId)=>{
            const params = new URLSearchParams({
                viewType
            });
            if (viewSourceId) {
                params.append('viewSourceId', String(viewSourceId));
            }
            if (sharedOnly === true) {
                params.append('sharedOnly', 'true');
            }
            return this.get(`${baseUrl}?${params.toString()}`);
        }), _define_property(this, "customiseView", (payload)=>this.put(`${baseUrl}/customise`, payload)), _define_property(this, "customiseProjectTaskListView", (projectId, payload)=>this.put(`${baseUrl}/project/${projectId}/customise`, payload)), _define_property(this, "getProjectListViews", ()=>this.get(`${baseUrl}?viewType=${ViewType.ProjectList}`)), _define_property(this, "getSprintListViews", ()=>this.get(`${baseUrl}?viewType=${ViewType.SprintList}`)), _define_property(this, "getEpicListViews", ()=>this.get(`${baseUrl}?viewType=${ViewType.EpicList}`)), _define_property(this, "getBacklogListViews", ()=>this.get(`${baseUrl}?viewType=${ViewType.BacklogList}`)), _define_property(this, "getAllViewsCustomRpeort", (viewType, viewSourceId, sharedOnly)=>{
            const params = new URLSearchParams({
                viewType,
                viewSourceId: String(viewSourceId)
            });
            if (sharedOnly === true) {
                params.set('sharedOnly', 'true');
            }
            return this.get(`${baseUrl}?${params.toString()}`);
        }), _define_property(this, "saveView", (view)=>this.post(baseUrl, view)), _define_property(this, "updateView", (view)=>this.put(`${baseUrl}/${view.viewId}`, view)), _define_property(this, "deleteView", (view)=>this.delete(`${baseUrl}/${view.viewId}`)), _define_property(this, "getAllProjectTaskViews", (projectId)=>this.get(`${baseUrlProject}/${projectId}?viewType=${ViewType.ProjectTaskList}`));
    }
}
export const ViewApI = new ViewClient();
